import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  getFormValues
} from "redux-form";
import { TextField } from "redux-form-material-ui";
import { required } from "../../common/Validations";
import { 
  Container, 
  Box, 
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  Grid,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Select,
  Toolbar,
  MenuItem,
  Chip,
  FormHelperText,  
} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import Util, { ERROR, SUCCESS, handleSubmitFail } from '../../common/Util'
import { actionSaveTag } from '../../actions/TagActions'
import ColorField from "../../components/ColorField/ColorField";
import DeleteIconChip from "@material-ui/icons/HighlightOff"

let _handleSubmitFail;
class AddEditTag extends React.PureComponent{
  constructor(props){
    super(props)
    this.onClean=this.onClean.bind(this)
    this.onSave=this.onSave.bind(this)
    _handleSubmitFail=this.handleSubmitFail.bind(this)
    this.state = {previewColor:props.formValues.tagColor, invalidColor:false}
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);
    }
    
    if(this.props.isEditing){
      let tag=this.props.history.location.state//this.props.tag
      console.log("TAG", tag)
      if(tag){  
        this.props.initialize(tag)
        this.setState({previewColor:tag.tagColor})
      }else{
        this.props.history.replace(LOGIN_ROUTE);
      }
    }else{
      this.props.initialize({isTagVisible:false, tagColor:"#000000"})
    }
  }
  
  handleSubmitFail(error){
    console.log("ERROR EN EL SUBMIT", error)
  }

  onClean(){
    if(this.props.isEditing){
      let tag=this.props.history.location.state//this.props.tag
      this.props.initialize(tag)
      this.setState({previewColor:tag.tagColor})
    }else{
      this.props.initialize({isTagVisible:false, tagColor:"#000000"})
    }
  }

  onSave(formValues){
    if(!formValues.tagColor.match(/^#(?:[0-9a-fA-F]{3}){2}$/)){
      formValues.tagColor ="#000000"
    }
    this.props.actionSaveTag(formValues
      , ()=>{Util.showNoty(SUCCESS, "El tag se guardó correctamente."); this.props.history.goBack()}
      , (e)=>{
        console.log("ERROR ON SAVE TAG", e)
        if(!(e&&e.status&&e.status==401))
          Util.showNoty(ERROR, "No se pudo guardar el tag.")
      }
    )
  
  }

  onDeleteTag(tag){
    Util.showNoty(SUCCESS, "Vista Previa del Tag")
  }

  render(){
    const { theme, handleSubmit, isEditing, formValues } = this.props
    const title = isEditing?"Editar Tag":"Crear Tag"
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Tag</Typography>
            <Typography variant="subtitle1">{title}</Typography>
          </Box>
        </Box>
        <Container>        
          <Paper >
            <form style={theme.paper.form}>
              <Grid container xs={12} spacing={3} direction="row">
                <Grid item xs={4}>
                  <Field
                    component={TextField}
                    name="tagName"
                    label="Nombre"
                    fullWidth
                    validate={[required]}
                  />   
                </Grid>
                <Grid item xs={4} style={{alignSelf:"end"}}>
                    <ColorField
                        input={{
                          value: formValues.tagColor,
                          onChange: (evt) => {
                            this.props.change('tagColor', evt.target.value);
                            if(evt.target.value.match(/^#(?:[0-9a-fA-F]{3}){2}$/)){  
                                this.setState({previewColor:evt.target.value})
                              }else{
                                this.setState({previewColor:"#000000"})
                            }
                          }
                        }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <InputLabel shrink>¿Es visible el tag en la app?</InputLabel>
                    <Select
                        value={formValues.isTagVisible}
                        onChange={(evt) => {
                            this.props.change('isTagVisible',evt.target.value );
                        }}
                    >
                      <MenuItem value={true}>SI</MenuItem>
                      <MenuItem value={false}>NO</MenuItem>
                    </Select>
                </Grid>
                <Grid item xs={2}>
                  <InputLabel shrink>Vista Previa</InputLabel>
                  <Chip
                    label={formValues.tagName||"Tag"}
                    style={{ backgroundColor: this.state.previewColor, color:theme.palette.getContrastText(this.state.previewColor) }}
                    onDelete={this.onDeleteTag.bind(this, formValues)}
                    deleteIcon={<DeleteIconChip style={{color:theme.palette.getContrastText(this.state.previewColor), opacity:0.6 }} />}
                  />
                </Grid>
              </Grid>
            </form>
          </Paper>
          <Toolbar style={theme.footer.toolbar}>
            <Tooltip title="Limpiar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.onClean}>Limpiar</Button>
            </Tooltip>
            <Tooltip title="Cancelar">
              <Button variant="contained" color="secondary" style={theme.footer.button} onClick={this.props.history.goBack}>Cancelar</Button>
            </Tooltip>
            <Tooltip title="Guardar">
              <Button variant="contained" color="primary" style={theme.footer.button} onClick={handleSubmit(this.onSave)}>Guardar</Button>
            </Tooltip>
          </Toolbar>
        </Container>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  return {
    login: store.auth.login,
    tag: store.tag.tag,
    formValues: store.form&&store.form.addEditTag&&store.form.addEditTag.values||[]
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionSaveTag,
    },
    dispatch
  );
}

export default  reduxForm({
  form: "addEditTag",
  initialValues:{isTagVisible:false, tagColor:"#000000"},
  onSubmitFail: errors => _handleSubmitFail(errors)
})(withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(AddEditTag)
    )
  )
)


// WEBPACK FOOTER //
// ./src/screens/tags/AddEditTag.js